/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\Header\Header.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Tuesday June 6th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 5th February 2024 04:22:06
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import RouterPathResolver from "Config/Router/RouterPathResolver";
import { useUserContext } from "Hooks/useUserContext";
import translator from "MultiLanguage/TranslationWrapper";
import { AiOutlinePoweroff } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useAuth } from "Router/AuthProvider";
import UserSession from "Utils/UserSession";

function Header(_: any){
    const {isConnected, logout} = useAuth();
    const {Name} = useUserContext();

    return (
        <header className="p-3 d-flex justify-content-between align-items-center border-bottom">
            <Link className="w-25" to={RouterPathResolver.pathHome.path}>
                <img style={{width:"75%"}} src="/logo.png" alt="Logo Société" />
            </Link>
            {isConnected ?
                <div className="d-flex flex-column align-items-end">
                    <p className="m-0">{Name}</p>
                    <Link to="/login" onClick={() => {logout(); UserSession.signOut()}}>
                        <div className="d-flex align-items-center">
                            <h4 className="me-2"> {translator.decode("dynamic.logout")} </h4>
                            <AiOutlinePoweroff fill="red"/>
                        </div>
                    </Link>
                </div>
            : <></>}
        </header>
    )
}

export default Header;
